import { clsx, type ClassValue } from "clsx"
import { twMerge } from "tailwind-merge"

export function cn(...inputs: ClassValue[]) {
  return twMerge(clsx(inputs))
}

export function getRefCode(id: string): string {
  return `E-Signature ID: ${id.toUpperCase()}`;
}

export function getSignerAuthCode(signerId: string): string {
  const hex = signerId.replace(/-/g, "").toUpperCase();
  return `SIG-${hex.slice(0, 4)}-${hex.slice(4, 8)}-${hex.slice(8, 12)}-${hex.slice(12, 16)}`;
}

function getLocalTimezone(): string {
  try {
    return Intl.DateTimeFormat().resolvedOptions().timeZone;
  } catch {
    return "America/New_York";
  }
}

export function formatPST(date: string | Date, options?: { dateOnly?: boolean }): string {
  const d = typeof date === "string" ? new Date(date) : date;
  const tz = getLocalTimezone();
  if (options?.dateOnly) {
    return d.toLocaleDateString("en-US", { year: "numeric", month: "long", day: "numeric", timeZone: tz });
  }
  return d.toLocaleString("en-US", { timeZone: tz, year: "numeric", month: "short", day: "numeric", hour: "2-digit", minute: "2-digit", timeZoneName: "short" });
}
